import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const ClockIcon = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path
      fill={props.fill}
      d="m13.025 13.577.552-.551-3.186-3.19V5.873h-.77v4.289l3.404 3.416Zm-3.021 3.795a7.186 7.186 0 0 1-2.877-.581 7.456 7.456 0 0 1-2.344-1.577 7.432 7.432 0 0 1-1.576-2.34 7.172 7.172 0 0 1-.58-2.87c0-1.02.195-1.978.582-2.876a7.456 7.456 0 0 1 1.577-2.344 7.43 7.43 0 0 1 2.34-1.576 7.172 7.172 0 0 1 2.87-.58c1.02 0 1.978.194 2.876.581.899.388 1.68.913 2.344 1.577a7.43 7.43 0 0 1 1.576 2.34c.386.895.58 1.852.58 2.87 0 1.02-.194 1.979-.581 2.877a7.458 7.458 0 0 1-1.577 2.344 7.433 7.433 0 0 1-2.34 1.576 7.172 7.172 0 0 1-2.87.579Zm-.004-.77c1.828 0 3.386-.643 4.672-1.93 1.287-1.286 1.93-2.843 1.93-4.672 0-1.828-.643-3.386-1.93-4.672-1.286-1.287-2.844-1.93-4.672-1.93-1.829 0-3.386.643-4.673 1.93C4.04 6.614 3.397 8.172 3.397 10c0 1.829.643 3.386 1.93 4.673s2.844 1.93 4.673 1.93Z"
    />
  </Svg>
)
export default ClockIcon